import EtnersCommonUtil from './etners.common.util'

/**
 * 순수하게 자바스크립트로 된
 * 날짜/시간 관련 유틸 함수 모듈
 */

const lookupDateByTodayMidnight = () => {
  let dt = new Date()

  let yyyy = dt.getFullYear()
  let mm = dt.getMonth()
  let dd = dt.getDate()

  return new Date(yyyy, mm, dd, 0, 0, 0)
}

const lookupDateTime = () => {
  let dt = new Date()

  let yyyy = dt.getFullYear()
  let mm = dt.getMonth()
  let dd = dt.getDate()
  let hh = dt.getHours()
  let minutes = dt.getMinutes()
  return new Date(yyyy, mm, dd, hh, minutes)
}

const TODAY_DATETIME = lookupDateByTodayMidnight()

const lookupDateYYYYMMDD = (yyyymmdd) => {

    if(yyyymmdd == undefined) {
      return lookupDateByTodayMidnight()
    }

    if(EtnersCommonUtil.getMatchType(yyyymmdd) != 'STRING') {
      throw new Exception('잘못된 값입니다')
    }

    let yyyy = Number(yyyymmdd.substring(0, 4))
    let mm = Number(yyyymmdd.substring(4, 6)) - 1
    let dd = Number(yyyymmdd.substring(6, 8))

    return new Date(yyyy, mm, dd, 0, 0, 0)
}

const lookupDateTimeHHMM = (hhmi) => {
    if(EtnersCommonUtil.getMatchType(hhmi) != 'STRING') {
        throw new Exception('잘못된 값입니다')
    }

    let yyyy = TODAY_DATETIME.getFullYear()
    let mm = TODAY_DATETIME.getMonth()
    let dd = TODAY_DATETIME.getDate()

    let hh = hhmi.substring(0, 2)
    let mi = hhmi.substring(2, 4)

    return new Date(yyyy, mm, dd, hh, mi, 0)
}

const lookupDateTimeYYYYMMDDHHMM = (yyyymmdd, hhmi) => {

  if(EtnersCommonUtil.getMatchType(yyyymmdd) != 'STRING') {
    throw new Exception('잘못된 값입니다')
  }

  if(EtnersCommonUtil.getMatchType(hhmi) != 'STRING') {
    throw new Exception('잘못된 값입니다')
  }

  let yyyy = Number(yyyymmdd.substring(0, 4))
  let mm = Number(yyyymmdd.substring(4, 6)) - 1
  let dd = Number(yyyymmdd.substring(6, 8))

  let hh = hhmi.substring(0, 2)
  let mi = hhmi.substring(2, 4)

  return new Date(yyyy, mm, dd, hh, mi, 0)
}

const isEmpty = (arg) => {
    if (arg === undefined || arg === null || arg === "null") {
        return true;
    }

    let type = getMatchType(arg);

    let flag = false;

    switch (type) {
        case "NUMBER" :
            flag = false;
            break;
        case "ARRAY" :
            flag = arg.length == 0;
            break;
        case "STRING" :
            try {
                flag = arg.trim().length == 0;
            } catch (e) {
                String.prototype.trim = function() {
                    return this.replace(/^\s+|\s+$/g, '');
                }

                flag = arg.trim().length == 0;
            }
            break;
        case "OBJECT" :
            try {
                flag = Object.keys(arg).length == 0;
            } catch (e) {
                let count = 0;

                for(let key in arg) {
                    count++;
                }

                flag = count == 0;
            }
            break;
    }

    return flag;
}

const isNotEmpty = (arg) => {
    return !isEmpty(arg);
}

const dateToYYYYMMDD = function(date) {
  return date.getFullYear() +  convertTwoDigit(date.getMonth() + 1) +  convertTwoDigit(date.getDate())
}

const dateToYYYYMMDDWithPoint = function(date, separator) {
  if(separator == undefined) {
    separator = "."
  }

  return `${date.getFullYear()}${separator}${convertTwoDigit(date.getMonth() + 1)}${separator}${convertTwoDigit(date.getDate())}`
}

const dateToHHMISS = function(date, separator) {
  if(separator == undefined) {
    separator = ""
  }

  return `${convertTwoDigit(date.getHours())}${separator}${convertTwoDigit(date.getMinutes())}${separator}${convertTwoDigit(date.getSeconds())}`
}

const dateToHHMI = function(date, separator) {
  if(separator == undefined) {
    separator = ""
  }

  return convertTwoDigit(date.getHours()) + separator +  convertTwoDigit(date.getMinutes())
}

const dateToYYYYMMDDHHMI = function(date, separator) {
  if(separator == undefined) {
    separator = "."
  }

  return `${date.getFullYear()}${separator}${convertTwoDigit(date.getMonth() + 1)}${separator}${convertTwoDigit(date.getDate())} ${convertTwoDigit(date.getHours())}:${convertTwoDigit(date.getMinutes())}`
}

const getDayOfWeek = function(date) {
  const week = ['일', '월', '화', '수', '목', '금', '토']

  return week[date.getDay()]
}



const nowYYYYMM = function() {
  const date = new Date()

  return date.getFullYear() +  convertTwoDigit(date.getMonth() + 1)
}

const convertTwoDigit = function(number) {
  if(number < 10) {
    return `0${number}`
  } else {
    return `${number}`
  }
}



const calculateGapToMiliSeconds = function(startDate, endDate) {
  let gapMiliseconds = endDate.getTime() - startDate.getTime()

  return gapMiliseconds
}


const calculateGapToSeconds = function(startDate, endDate) {
  return calculateGapToMiliSeconds(startDate, endDate) / 1000
}


const calculateGapToMinutes = function(startDate, endDate) {
  return calculateGapToSeconds(startDate, endDate) / 60
}

const isAfterTime = function(targetDate, compareDate) {
  return calculateGapToMiliSeconds(targetDate, compareDate) > 0 ? true : false
}

const isSameTime = function(targetDate, compareDate) {
  return calculateGapToMiliSeconds(targetDate, compareDate) == 0 ? true : false
}

const convertGapTimeToTextKo = function(gapMinutes) {
  if(gapMinutes < 0) {
    throw new Exception("0보다 값이 작을 수 없습니다.")
  }

  if(gapMinutes == 0) {
    return "0분"
  }

  let tempText

  if(gapMinutes / 60 > 0) {

      if(gapMinutes % 60 == 0) {
        tempText = `${Math.floor(gapMinutes / 60)}시간`
      } else {

        if( Math.floor(gapMinutes / 60) > 0 ) {
          tempText = `${Math.floor(gapMinutes / 60)}시간 ${gapMinutes % 60}분`
        } else {
          tempText = `${gapMinutes}분`
        }

      }

  } else {
      tempText = `${gapMinutes}분`
  }

  return tempText
}

const convertGapTimeToHours = function(gapMinutes) {
  if(gapMinutes < 0) {
    throw new Exception("0보다 값이 작을 수 없습니다.")
  }

  if(gapMinutes == 0) {
    return 0
  }

  let tempNumber

  let hours = Math.floor((gapMinutes / 60) * 10)

  tempNumber = hours / 10

  return tempNumber
}

const convertGapTimeHHMI = function(gapMinutes) {
  if(gapMinutes < 0) {
    throw new Exception("0보다 값이 작을 수 없습니다.")
  }

  if(gapMinutes == 0) {
    return "0000"
  }

  let tempText

  if(gapMinutes / 60 > 0) {

      if(gapMinutes % 60 == 0) {
        tempText = `${convertTwoDigit(Math.floor(gapMinutes / 60))}00`
      } else {

        if( Math.floor(gapMinutes / 60) > 0) {
          tempText = `${convertTwoDigit(Math.floor(gapMinutes / 60))}${convertTwoDigit(gapMinutes % 60)}`
        } else {
          tempText = `00${convertTwoDigit(gapMinutes)}`
        }

      }

  } else {
      tempText = `00${convertTwoDigit(gapMinutes)}`
  }

  return tempText
}

const calculateBreakTimeToMinutes = function(workTimeMinutes) {
  let workHours = Math.floor(workTimeMinutes / 60)

  console.log(`workTimeMinutes : ${workTimeMinutes} / workHours : ${workHours}`)

  let breakMinutes

  if(workHours < 4) {
    breakMinutes = 0
  } else if(4 <= workHours && workHours < 8) {
    breakMinutes = 30
  } else if(8 <= workHours && workHours < 12) {
    breakMinutes = 60
  } else if(12 <= workHours && workHours < 16) {
    breakMinutes = 90
  } else if(16 <= workHours && workHours < 20) {
    breakMinutes = 120
  } else if(20 <= workHours && workHours < 24) {
    breakMinutes = 150
  } else if(workHours == 24) {
    breakMinutes = 180
  }

  console.log(`breakMinutes : ${breakMinutes}`)

  return breakMinutes
}

const dayOfWeek = function(date, mode) {
  if(mode == undefined) {
    mode = "FULL"
  }

  if(mode !== "FULL" && mode !== "SHORT") {
    throw new Exception("지원하지 않는 모드값입니다.")
  }

  const dayOfWeekArray = new Array(7)

  switch(mode) {
    case "FULL" :
      dayOfWeekArray[0] = "Sunday"
      dayOfWeekArray[1] = "Monday"
      dayOfWeekArray[2] = "Tuesday"
      dayOfWeekArray[3] = "Wednesday"
      dayOfWeekArray[4] = "Thursday"
      dayOfWeekArray[5] = "Friday"
      dayOfWeekArray[6] = "Saturday"
      break;
    case "SHORT" :
      dayOfWeekArray[0] = "Sun"
      dayOfWeekArray[1] = "Mon"
      dayOfWeekArray[2] = "Tue"
      dayOfWeekArray[3] = "Wed"
      dayOfWeekArray[4] = "Thu"
      dayOfWeekArray[5] = "Fri"
      dayOfWeekArray[6] = "Sat"

      break;
    default :
      throw new Exception("지원하지 않는 모드값입니다.")
  }

  return dayOfWeekArray[date.getDay()]
}

const dateToScopeYYMMDD = function(startDate, endDate) {
  const startDayFullYear = startDate.getFullYear() + ""
  const endDayFullYear   = endDate.getFullYear()   + ""

  const textStartDayYYMMDD = `${startDayFullYear.substring(2, 4)}.${convertTwoDigit(startDate.getMonth() + 1)}.${convertTwoDigit(startDate.getDate())}`
  const textEndDayYYMMDD   = `${endDayFullYear.substring(2, 4)}.${convertTwoDigit(endDate.getMonth() + 1)}.${convertTwoDigit(endDate.getDate())}`

  return `${textStartDayYYMMDD}~${textEndDayYYMMDD}`
}

export default {
  lookupDateYYYYMMDD,
  lookupDateTimeHHMM,
  lookupDateTimeYYYYMMDDHHMM,
  isEmpty,
  isNotEmpty,
  lookupDateByTodayMidnight,
  lookupDateTime,
  dateToYYYYMMDD,
  dateToYYYYMMDDWithPoint,
  dateToHHMISS,
  dateToHHMI,
  dateToYYYYMMDDHHMI,
  nowYYYYMM,
  convertTwoDigit,
  calculateGapToMiliSeconds,
  calculateGapToSeconds,
  calculateGapToMinutes,
  isAfterTime,
  isSameTime,
  convertGapTimeToTextKo,
  convertGapTimeToHours,
  convertGapTimeHHMI,
  calculateBreakTimeToMinutes,
  dayOfWeek,
  dateToScopeYYMMDD,
  getDayOfWeek
}
